import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const memberName = style({
  listStyleType: 'disc',
  color: themeVars.color.semantic.text.neutral20,
});

const memberList = style({
  paddingLeft: themeVars.spacing.md,
});

export const css = {
  memberName,
  memberList,
};
